import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuthStore } from './lib/auth'
import { QueryProvider } from './providers/QueryProvider'

import LoginPage from './pages/Login'
import ForgotPasswordPage from './pages/ForgotPassword'
import DashboardPage from './pages/Dashboard'
import ProductsPage from './pages/Products'
import ProductDetailsPage from './pages/ProductDetails'
import CategoriesPage from './pages/Categories'
import BrandsPage from './pages/Brands'
import OrdersPage from './pages/Orders'
import OrderDetailPage from './pages/OrderDetail'
import CustomersPage from './pages/Customers'
import CustomerDetailPage from './pages/CustomerDetail'
import ReviewsPage from './pages/Reviews'
import CouponsPage from './pages/Coupons'
import ReturnRequestsPage from './pages/ReturnRequests'
import CreateCouponPage from './pages/CreateCoupon'
import PaymentsPage from './pages/Payments'
import AnalyticsPage from './pages/Analytics'
import ContactMessagesPage from './pages/ContactMessages'
import CarouselsPage from './pages/Carousels'
import ProfilePage from './pages/Profile'
import SettingsPage from './pages/Settings'
import AdminLayout from './components/AdminLayout'

// Protected Route Component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { token, userRole } = useAuthStore()

  if (!token || userRole !== 'ADMIN') {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default function App() {
  return (
    <QueryProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          <Route
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:id" element={<ProductDetailsPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/brands" element={<BrandsPage />} />
            <Route path="/carousels" element={<CarouselsPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/:id" element={<OrderDetailPage />} />
            <Route path="/return-requests" element={<ReturnRequestsPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/customers/:id" element={<CustomerDetailPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/coupons" element={<CouponsPage />} />
            <Route path="/coupons/create" element={<CreateCouponPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/contact-messages" element={<ContactMessagesPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Routes>

        <Toaster position="top-right" />
      </Router>
    </QueryProvider>
  )
}
